import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import styled from 'styled-components';
import Flex from 'src/components/common/Flex';
import { Hidden } from 'react-grid-system';
import Button from '#common/Button';
import { ProjectLinks, ProjectPreview } from './ProjectTemplate.style';

import PageHeader from '#common/PageHeader';
import { ParallaxProvider } from 'react-scroll-parallax';

import ProjectTemplate from './ProjectTemplate';

const Startup = () => (
  <Flex justify="center" align="center">
    <ParallaxProvider>
      <Flex justify="space-around" align="center">

        <img
          className="skill__icons"
          alt=""
          src={
            'https://res.cloudinary.com/dedozyu83/image/upload/v1599849963/79541971_156392045740898_5345323525584453632_o_pgrvgf.jpg'
          }
        />
        <img
          className="skill__icons"
          alt=""
          src={
            'https://res.cloudinary.com/dedozyu83/image/upload/v1599849957/78984540_156392355740867_8184464815691923456_o_oy5jue.jpg'
          }
        />


        <img
          className="skill__icons"
          alt=""
          src={
            'https://res.cloudinary.com/dedozyu83/image/upload/v1599849913/78981830_156396642407105_8210692325542723584_o_bctqjk.jpg'
          }
        />
      </Flex>
      <Hidden md xs sm></Hidden>
    </ParallaxProvider>
  </Flex>
);

const WorkWrapper = styled.section`
  ${props => props.theme.spacing.sectionBottom};
  position: relative;

  .skill__icons {
    padding: 30px 0;
    width: 30%;
    @media ${props => props.theme.media.tablet} {
      padding: 10px 0;
      width: 30%;
    }

    svg {
      color: ${props => props.theme.primaryColor};
    }
  }
  .skills__word-clouds {
    @media ${props => props.theme.media.tablet} {
      display: none;
    }

    p {
      position: absolute;

      color: ${props => props.theme.accentColor};
      z-index: -1;
      left: 0;
      right: 0;
      font-weight: 900;
    }
    z-index: -1;
  }
`;

const Work = () => {
  const work = useStaticQuery(
    graphql`
      query {
        allWorkJson {
          edges {
            node {
              description
              title
              id
              links {
                youtube
                image
              }
            }
          }
        }
      }
    `
  );

  return (
    <WorkWrapper id="work" style={{ marginBottom: 50 }}>
      <PageHeader>Work</PageHeader>
      <p style={{ textAlign: 'center', fontSize: 18, marginBottom: 50 }}>
        It's true that I make videos to help you learn how to code, design... However, I always love new experiences
        that gave me the opportunity to show my followers something new. I told you before that I hate routine.
        Therefore I organized a new youtube channel called Samar Tech.
      </p>

      <Startup />
      {work.allWorkJson.edges.map(({ node }) => (
        <ProjectTemplate
          key={node.id}
          title={node.title}
          desc={node.description}
          links={
            <ProjectLinks>
              <Button target="__blank" as="a" href={node.links.youtube}>
                Subscribe Now!
              </Button>
            </ProjectLinks>
          }
          preview={
            <ProjectPreview>
              <img style={{ width: '80%' }} src={node.links.image} alt="" />
            </ProjectPreview>
          }
        />
      ))}
      <ParallaxProvider>
        <Flex justify="space-around" align="center">
          <img
            className="skill__icons"
            alt=""
            src={
              'https://res.cloudinary.com/dftzxxmwq/image/upload/v1583837158/29496232_190428084908149_6921914468423172096_o_dyxiem.jpg'
            }
          />
          <img
            className="skill__icons"
            alt=""
            src={
              'https://res.cloudinary.com/dftzxxmwq/image/upload/v1583940854/29261490_189618554989102_5806547835730001920_o_gmfhys.jpg'
            }
          />
          <img
            className="skill__icons"
            alt=""
            src={
              'https://res.cloudinary.com/dftzxxmwq/image/upload/v1583940858/29342744_189618274989130_3757726243718430720_o_antpdv.jpg'
            }
          />
          <img
            className="skill__icons"
            alt=""
            src={
              'https://res.cloudinary.com/dftzxxmwq/image/upload/v1583940902/29387060_190428161574808_1181881695989661696_o_tlln5x.jpg'
            }
          />
          <img
            className="skill__icons"
            alt=""
            src={
              'https://res.cloudinary.com/dftzxxmwq/image/upload/v1583940652/30709087_197159917568299_4768500097652621312_o_kr4tkb.jpg'
            }
          />
          <img
            className="skill__icons"
            alt=""
            src={
              'https://res.cloudinary.com/dftzxxmwq/image/upload/v1583940861/29386592_190428508241440_1044769877291696128_o_x9kxhi.jpg'
            }
          />
        </Flex>
        <Hidden md xs sm></Hidden>
      </ParallaxProvider>
    </WorkWrapper>
  );
};

export default Work;
